import React, { useEffect, useState } from "react";
import moment from "moment";

const Table = ({ tableHeader, entries }) => {
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    if (entries && entries.length > 0) {
      let tempObject = Object.keys(entries[0].data);

      setHeaders(tempObject);
    }
  }, [entries]);

  const convertToSpaceSeparated = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b([A-Z]+)([A-Z])([a-z])/, "$1 $2$3")
      .replace(/^./, function (str) {
        return str.toUpperCase();
      });
  };

  return (
    <>
      <table className="w-full ">
        <thead className="bg-[#F4F4F4] rounded  py-2">
          <tr className="">
            <th
              className={
                "text-left px-6 capitalize whitespace-nowrap py-5 md:text-sm text-xs font-normal"
              }
            >
              Date
            </th>
            {headers.sort().map((column, index) => {
              // const titles = Object.keys(column);

              return (
                <>
                  {/* {titles.map((title, index) => ( */}
                  <th
                    className={
                      "text-left capitalize whitespace-nowrap py-5 px-6 md:text-sm text-xs font-normal"
                    }
                    // scope="col"
                    key={index}
                  >
                    {column === "msisdn"
                      ? "Phone number"
                      : convertToSpaceSeparated(
                          column?.toLowerCase().replace("_", " ")
                        )}
                  </th>
                  {/* ))} */}
                </>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {entries?.length < 1 ? (
            <tr className="w-full">
              <td className="text-center" colSpan="5">
                <div className="my-8 mx-auto">
                  <img
                    src={require("../../../assets/images/noData.svg")}
                    alt=""
                    className="mx-auto"
                  />
                </div>
              </td>
            </tr>
          ) : (
            entries.map((entrant, index) => {
              // const tableItems = Object.values(entrant.data);

              return (
                <tr
                  key={index}
                  className="hover:bg-[#F4F4F4] hover:cursor-pointer focus:bg-[#F4F4F4]"
                >
                  <td
                    className={`text-left px-6 text-xs md:text-sm ${"text-[#787878]"}  py-3 `}
                  >
                    {entrant.date
                      ? moment(new Date(entrant.date)).format(
                          "DD/MM/YYYY, h:mm:ss A"
                        )
                      : ""}
                  </td>

                  {/* {tableItems.map((items, i) => {
                    // console.log(items);
                    return (
                      <td
                        key={i}
                        className={`text-left  text-xs md:text-sm ${"text-[#787878]"}  py-3 pl-0`}
                      >
                        {items}
                      </td>
                    );
                  })} */}
                  <td
                    className={`text-left  px-6 text-xs md:text-sm ${"text-[#787878]"}  py-3 `}
                  >
                    {entrant.data.association}
                  </td>
                  <td className="text-left  px-6 text-xs md:text-sm text-[#787878] py-3 ">
                    {entrant.data.decoderNumber}
                  </td>

                  <td className="text-left px-6 text-xs md:text-sm text-[#787878] py-3">
                    {entrant?.data?.msisdn}
                  </td>
                  <td className="text-left px-6 capitalize text-xs md:text-sm text-[#787878] py-3">
                    {entrant?.data?.name?.toLowerCase()}
                  </td>
                  {/* <td className="text-left px-6 text-xs md:text-sm text-[#787878] py-3">
                    {entrant?.data.location}
                  </td> */}

                  <td className="text-left px-6 text-xs md:text-sm text-[#787878] py-3">
                    {entrant?.data?.region}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      {/* <div className="text-right py-4 px-5">
        <div className="flex items-center justify-end">
          <button
            onClick={() => handlePrevBtn()}
            disabled={
              pages &&
              page === [...Array(Math.max(0, pages - 1))].length - pages + 2
                ? true
                : false
            }
            className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          {pages &&
            [...Array(Math.max(0, pages))].map((value, index) => {
              if (
                index + 1 < maxPageNumberLimit + 1 &&
                index + 1 > minPageNumberLimit
              )
                return (
                  <button
                    key={index}
                    type="button"
                    onClick={(e) => handlePageNumberClick(e)}
                    className={
                      page === index + 1
                        ? " mx-1 py-1.5 px-3 rounded text-sm bg-[#FF6A3A] text-white"
                        : "bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-3 rounded text-sm hover:bg-[#FF6A3A] hover:text-white"
                    }
                  >
                    {index + 1}
                  </button>
                );
            })}
          <button
            onClick={() => handleNextBtn()}
            disabled={
              pages && page === [...Array(Math.max(0, pages))].length
                ? true
                : false
            }
            className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div> */}

      {/* <div>
        <Pagination
          page={page}
          setPage={setPage}
          pageNumberLimit={pageNumberLimit}
          maxPageNumberLimit={maxPageNumberLimit}
          setMaxPageNumberLimit={setMaxPageNumberLimit}
          minPageNumberLimit={minPageNumberLimit}
          setMinPageNumberLimit={setMinPageNumberLimit}
          data={allDrawWinners}
          itemsPerPage={itemsPerPage}
        />
      </div> */}
    </>
  );
};

export default Table;
